<template>
  <div class="border-t-8 border-red-500"/>
</template>

<script>
export default {

}
</script>